import { createContext} from 'react';

const MenuContext = createContext("TOP");

export default MenuContext;
